module.exports = __webpack_public_path__ + "media/customizations/camelback/logo-327fb4117af38e04cebe0ce6b337d889.png";